import Programs from "../components/Programs.js";
import Events from "../components/Events.js";
import GetInvolved from "../components/GetInvolved.js";
import Footer from "../components/Footer.js";

export default function ServicesPage() {
  return (
    <>
      <Programs />
      <Events />
      <GetInvolved />
      <Footer />
    </>
  );
}